import styled, { css } from 'styled-components'

const inputSizeStyles = {
  default: css`
    height: 42px;
    padding: 0 25px 0 19px;
  `,

  small: css`
    height: 32px;
    padding: 0 36px 0 12px;
  `,
}

export const InputWrap = styled.label`
  position: relative;
  display: block;
  word-break: break-word;
  margin-bottom: ${(p) => (p.marginBottom ? p.marginBottom : '0')};
  width: ${(p) => (p.half ? '50%' : '100%')};

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  &.has-error {
    input {
      border-color: var(--t-input-has-error);
      background-color: var(--t-input-has-error);
    }
  }

  &.has-success {
    input {
      border-color: var(--p-green-400);
    }
  }

  & .wmde-markdown {
    font-family: inherit;
    font-size: 14px;
    padding-right: 15px;
  }
`

export const InputLabel = styled.span`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 15px;
  color: var(--t-text-label);

  span {
    color: var(--t-forms-label-span-text);
  }
`

export const InputInner = styled.div`
  position: relative;

  /* svg {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    pointer-events: none;
  } */

  .errorIcon,
  .successIcon {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    pointer-events: none;
  }
`

export const InputElement = styled.input`
  width: 100%;
  border: 1px solid var(--t-surface-2);
  background-color: var(--t-surface-2);
  border-radius: 8px;
  transition: all 0.3s;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  color: var(--t-text-input);

  ${({ $size = 'default' }) => inputSizeStyles[$size]}

  &::placeholder {
    color: var(--t-text-secondary);
    opacity: 1;
  }

  &:not(:focus):hover {
    border-color: var(--t-input-hover);
  }

  &:focus {
    border-color: var(--t-action-accent);
    outline: none;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  &:disabled,
  &:disabled:hover,
  &:disabled:focus {
    background-color: var(--t-input-bg-disabled);
    border-color: var(--t-input-border-disabled);
    color: var(--t-input-text-disabled);
    pointer-events: none;
  }

  &:disabled::placeholder {
    color: var(--t-text-secondary);
  }

  ${(p) =>
    p.withIcon &&
    css`
      padding-left: 46px;
    `}/* ${(p) =>
    p.themeSize === 'middle' &&
    css`
      height: 48px;
    `} */
`

export const InputIcon = styled.div`
  width: 46px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const InputError = styled.div`
  color: var(--t-input-text-error);
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  margin-top: 5px;
`

export const IconContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 15px;
  margin-top: -6px;
  display: flex;
  align-items: center;
  width: 10px;
  height: 10px;
  z-index: 8;
  cursor: pointer;
`

export const EndIconContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 14px;
  display: flex;
  align-items: center;
  transform: translateY(-50%);
  z-index: 8;
  color: var(--p-neutral-500);
`
